/**
 * Validation Utilities
 */

export interface ValidationResult {
  valid: boolean;
  message?: string;
}

/**
 * Validate email format
 */
export const validateEmail = (email: string): ValidationResult => {
  // Check if empty
  if (!email || email.trim() === "") {
    return { valid: false, message: "Email is required" };
  }

  // Check length
  if (email.length > 254) {
    return { valid: false, message: "Email is too long" };
  }

  // Check format
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!EMAIL_REGEX.test(email)) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  return { valid: true };
};

/**
 * Validate magic link code format
 */
export const validateMagicLinkCode = (code: string): ValidationResult => {
  if (!code || code.trim() === "") {
    return { valid: false, message: "Code is required" };
  }

  // Code should be alphanumeric and reasonable length
  if (code.length < 10 || code.length > 200) {
    return { valid: false, message: "Invalid code format" };
  }

  return { valid: true };
};
